import type { ContextState, Dictionary, Filter } from '../../../models'
import { getStateToolKey } from './get-state-tool-key'

export function mapFilters(filters: Dictionary<Filter>, state: ContextState): Dictionary<Filter> {
  const result: Dictionary<Filter> = {}

  for (const key in filters) {
    const filter = filters[key]

    result[key] = mapFilter(key, filter, state)
  }

  return result
}

export function mapFilter(key: string, filter: Filter, state: ContextState): Filter {
  const persistedToolValues = state.currentFeature
    ? state[getStateToolKey(state)]?.selectedFiltersValues?.[key]
    : undefined

  return {
    ...filter,
    selectedValues: persistedToolValues ?? filter?.selectedValues ?? [],
  }
}
